'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUIPagePanel = function AUIPagePanel(props) {
    var nav = void 0;
    if (props.nav) {
        nav = _react2.default.createElement(
            'div',
            { className: 'aui-page-panel-nav' },
            props.nav
        );
    }

    var aside = void 0;
    if (props.aside) {
        aside = _react2.default.createElement(
            'div',
            { className: 'aui-page-panel-sidebar content-sidebar' },
            props.aside
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'aui-page-panel', style: props.style },
        _react2.default.createElement(
            'div',
            { className: 'aui-page-panel-inner' },
            nav,
            _react2.default.createElement(
                'section',
                { className: 'aui-page-panel-content content-body' },
                props.children
            ),
            aside
        )
    );
};

AUIPagePanel.displayName = 'AUIPagePanel';
AUIPagePanel.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
    nav: _propTypes2.default.node,
    aside: _propTypes2.default.node,
    style: _propTypes2.default.object
};

exports.default = AUIPagePanel;
//# sourceMappingURL=AUIPagePanel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUIPagePanel.js
// module id = 75
// module chunks = 0